import { Component, OnInit } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Logger } from '@app/core/logger.service';
import { AlertController, ModalController } from '@ionic/angular';
import * as moment from 'moment';
const log = new Logger('SelectNewFileComponent');
@Component({
  selector: 'app-select-new-file',
  templateUrl: './select-new-file.component.html',
  styleUrls: ['./select-new-file.component.scss'],
})
export class SelectNewFileComponent implements OnInit {
  id!: string;
  public file!: File;

  constructor(
    private modalController: ModalController,
    private alertController: AlertController,
    private storage: AngularFireStorage,
    private afs: AngularFirestore,
  ) { }

  ngOnInit() { }

  closeModal() {
    this.modalController.dismiss();
  }

  selectFile(event: any) {
    try {
      this.file = event.target.files[0];
      log.debug(this.file);
    } catch (error) {
      log.error(error);
    }
  }

  async send() {
    try {
      if (this.file && this.id) {
        const ref = this.storage.ref(`chats-batch/${moment().valueOf()}-${this.file.name}`);
        const updload = await ref.put(this.file);
        const fullPath = updload.ref.fullPath;
        const path: string = 'chats-batch';
        const docRef: DocumentReference<any> = this.afs.doc(`${path}/${this.id}`).ref;
        const resp = await docRef.get();
        let data: any = resp.data();
        data.fullPath = fullPath;
        data.error = null;
        await docRef.delete();
        await this.afs.collection(path).add(data);
        log.debug("=== Correcto! ===", data);
        this.successAlert();
        this.closeModal();
      }
    } catch (error) {
      log.error(error);
    }
  }

  async successAlert(): Promise<void> {
    const alert = await this.alertController.create({
      header: '¡Correcto!',
      message: `Se a iniciado el proceso de envío de chats.`,
      buttons: [
        {
          text: 'Ok'
        }
      ]
    });
    return await alert.present();
  }

}
